<template>
  <div class="contents">
        <div class="customer_wrap">
            <div class="cs_card">
                <div class="box">
                    <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
                    <p>고객센터 이용안내</p>
                    <h5>070.4233.0655</h5>
                    <span>FAX : 02)478-5822</span>
                </div>
                <p>운영시간</p>
                <span>월-금 09:00~17:30</span>
            </div>
            <div class="cs_tab">
                <CustomerServiceNavigation/>
                <div class="cs_tabPanel active" id="cs_tab01">
                    <div class="notiDtl_wrap">
                        <div class="tit_area">
                            <h4 class="tit">
                                {{ notice.title }}
                            </h4>
                            <div>
                                <div class="date">
                                    <span>작성일</span>
                                    {{ notice.createDate }}
                                </div>
                                <div class="view">
                                    <span>조회</span>
                                    {{ notice.viewCnt }}
                                </div>
                            </div>
                        </div>
                        <div class="cont_area">
                            <p style="font-weight: bold; font-size: 18px; letter-spacing: -1.08px; color: #333; line-height: 48px;">디지털화환과 함께 기쁨의 선물 준비하세요.</p>
                            <p style="font-weight: 500; font-size: 18px; letter-spacing: -1.08px; color: #333; line-height: 48px;" v-html="notice.content">
                            </p>
                        </div>
                        <div class="file_area">
                            <div>첨부파일</div>
                            <ul>
                                <li 
                                    v-if="notice.attachList && notice.attachList.length > 0"
                                    v-for="attach in notice.attachList"
                                >
                                    <a :href="$downloadFile(attach.path, attach.originalName)">{{ attach.originalName }}</a>
                                </li>
                                <li v-else><a>첨부파일이 없습니다</a></li>
                            </ul>
                        </div>
                        <div class="moving_area">
                            <div class="prev">
                                <div class="tit">이전</div>
                                <p v-if="notice.nextPrevNotice && notice.nextPrevNotice.prevNoticeSeq"><a @click="toNotice(notice.nextPrevNotice.prevNoticeSeq)">{{ notice.nextPrevNotice.prevNoticeTitle }}</a></p>
                                <p v-else><a>이전글이 없습니다.</a></p>
                            </div>
                            <div class="next">
                                <div class="tit">다음</div>
                                <p v-if="notice.nextPrevNotice && notice.nextPrevNotice.nextNoticeSeq"><a @click="toNotice(notice.nextPrevNotice.nextNoticeSeq)">{{ notice.nextPrevNotice.nextNoticeTitle }}</a></p>
                                <p v-else><a>다음글이 없습니다.</a></p>
                            </div>
                        </div>
                        <div class="btn_area">
                            <a @click="toList" class="btn_list">목록</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomerServiceNavigation from '@/views/customerService/layout/CustomerServiceNavigation.vue';
import { mapActions, mapState } from 'vuex';

const noticeModule = 'noticeModule'

export default {
  components: {
    CustomerServiceNavigation
  },

  props: {
    noticeSeq: {
      type: String,
      required: true
    }
  },

  methods: {
    ...mapActions(noticeModule, ['requestNoticeDtl']),

    toNotice(noticeSeq) {
      this.$router.push({
        name: 'NoticeDtlPage',
        params: { noticeSeq: noticeSeq.toString() }
      })
    },

    toList() {
      this.$router.push({ name: 'NoticeListPage' })
    }
  },

  computed: {
    ...mapState(noticeModule, ['notice'])
  },

  async mounted () {
    await this.requestNoticeDtl(this.noticeSeq)
  },

  watch: {
    '$route.params.noticeSeq': {
      immediate: false,
      async handler(newNoticeSeq) {
        await this.requestNoticeDtl(newNoticeSeq);
      }
    }
  }
}
</script>
<style>

</style>